import React from "react";
import { isEven } from "../../base/utils";
import { fractionMap } from "./utils";

const RecipeKitchenTools = ({ kitchenTool, index }) => {
  let isIndexEven = isEven(index);
  let classes = !isIndexEven
    ? "A-Center Row Medium-Font Light-Grey px-10 py-6"
    : "A-Center Row Medium-Font px-10 py-6";

  // Convert fraction string to Unicode character, or use original if not found
  const typeOf = fractionMap[kitchenTool.type_of] || kitchenTool.type_of;

  let isKitchenToolPlural =
    kitchenTool.name[kitchenTool.name.length - 1] === "s";

  const formattedName =
    kitchenTool.quantity > 1 && !isKitchenToolPlural
      ? `${kitchenTool.name}s`
      : kitchenTool.name;

  return (
    <div className={classes}>
      <p className="marg-0">-</p>
      <div className="A-Center Row Space-B w-100">
        <p className="marg-0 marg-left-5">
          {typeOf} {formattedName}
        </p>
        <p className="marg-0">{kitchenTool.quantity}</p>
      </div>
    </div>
  );
};

export default RecipeKitchenTools;
